import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';
import { BankCardSetComponent } from '../bank-card-set/bank-card-set.component';
import { BankArchiveStatus, BankCards, BankCardsFilters, BankCardsParameters } from '../bank.model';

@Component({
	selector: 'app-bank-cards',
	templateUrl: './bank-cards.component.html',
	styleUrls: ['./bank-cards.component.css'],
})
export class BankCardsComponent extends ListComponent {
	protected itemsBeforeDataLoad = 3;
	protected apiUrl = 'bankCards';
	tableRows: { id: string; name: string }[] = [
		{ id: 'number', name: 'Numer' },
		{ id: 'currentOwnerName', name: 'Obecny właściciel' },
		{ id: 'comments', name: 'Komentarz' },
		{ id: 'status', name: 'Archiwum' },
	];
	addNumber = '';
	filters: BankCardsFilters;
	parameters: BankCardsParameters = {
		yesno: [
			{ id: 1, name: 'Nie' },
			{ id: 2, name: 'Tak' },
		],
		users: [],
		vehicles: [],
	};

	protected loadBefore(): void {
		this.api.get('/users/', (result, error) => {
			this.parameters.users = result.data;
			this.loadData();
		});
		this.api.get('/vehicles/', (result, error) => {
			this.parameters.vehicles = result.data;
			this.loadData();
		});
	}

	protected convertData(data: BankCards[]): BankCards[] {
		data.forEach((obj) => {
			obj.status = obj.status === BankArchiveStatus.INACTIVE ? 'Tak' : 'Nie';
		});
		return data;
	}

	dialogOpen(): void {
		new BankCardSetComponent(this.api, this.infobox, this.router).dialogOpen();
	}
}
